import get from 'transmute/get';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Meet... Remove this comment to see the full error message
import { meetingsVerifyError as meetingsVerifyErrorSelector } from 'MeetingsAdmin/selectors/RequestStatusSelector';
import { getCentralizedCalendarConnected as getCentralizedCalendarConnectedSelector, getCentralizedCalendarMeetingsEnabled as getCentralizedCalendarMeetingsEnabledSelector } from 'MeetingsAdmin/selectors/CentralizedCalendarSelectors';
import { getMeetingsSettingsLink } from 'MeetingsAdmin/utils/utils';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { View } from 'foundations-components/components/View';
import AuthErrorAlert from '../integration/AuthErrorAlert';
import { AUTH_ERROR_TYPES } from 'MeetingsBase/constants/enums';
import useQueryParams from '../../hooks/useQueryParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LoadableConnectCalendarModal = Loadable({
  loader: () => import( /* webpackChunkName: "connect-calendar" */'../integration/ConnectCalendarModal')
});
const useConnectCalendarQueryParam = () => {
  const query = useQueryParams();
  const {
    connectCalendar
  } = query;
  if (connectCalendar && typeof connectCalendar === 'string' && (connectCalendar.toLowerCase() === 'true' || connectCalendar === '1')) {
    return true;
  }
  return false;
};
export default function FixIntegrationWarning() {
  const [connectFlowOpen, setConnectFlowOpen] = useState(false);
  const [oauthError, setOAuthError] = useState(null);
  const [oauthErrorHidden, setOAuthErrorHidden] = useState(false);
  const connectCalendarParam = useConnectCalendarQueryParam();
  useEffect(() => {
    if (connectCalendarParam) {
      setConnectFlowOpen(true);
    }
  }, [connectCalendarParam]);
  const meetingsUser = useSelector(state => state.meetingsUser);
  const meetingsVerifyError = useSelector(state => meetingsVerifyErrorSelector(state));
  const isCentralizedCalendarConnected = useSelector(state => getCentralizedCalendarConnectedSelector(state));
  const isCentralizedCalendarMeetingsEnabled = useSelector(state => getCentralizedCalendarMeetingsEnabledSelector(state));
  if (!meetingsVerifyError || isCentralizedCalendarConnected && isCentralizedCalendarMeetingsEnabled) {
    return /*#__PURE__*/_jsx("div", {
      "data-selenium-test": "no-meetings-reconnect-warning"
    });
  }
  if (isCentralizedCalendarConnected && !isCentralizedCalendarMeetingsEnabled) {
    return /*#__PURE__*/_jsxs(Alert, {
      marginBlockEnd: "400",
      padding: "500",
      type: "warning",
      closeable: false,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendarView.fixMeetingsSettingCta.title"
      }),
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendarView.fixMeetingsSettingCta.body"
      }), /*#__PURE__*/_jsx(Button, {
        marginInlineStart: "600",
        "data-selenium-test": "fix-meetings-settings-button",
        external: true,
        href: getMeetingsSettingsLink('connectMeetings=true'),
        size: "small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "calendarView.fixMeetingsSettingCta.action"
        })
      })]
    });
  }
  let oauthErrorAlert = null;
  if (oauthError && !oauthErrorHidden) {
    let errorReason = get('calendarIntegrationChoice', meetingsUser) || AUTH_ERROR_TYPES.DEFAULT;
    let errorContext = null;
    if (oauthError.message === AUTH_ERROR_TYPES.SHARED_INBOX_INVALID_DOWNGRADE) {
      errorReason = AUTH_ERROR_TYPES.SHARED_INBOX;
      errorContext = {
        emailAddress: oauthError.emailAddress
      };
    }
    oauthErrorAlert = /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(AuthErrorAlert, {
        onClose: () => setOAuthErrorHidden(true),
        reasonKey: errorReason,
        errorContext: errorContext
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [oauthErrorAlert, /*#__PURE__*/_jsxs(Alert, {
      marginBlockEnd: "400",
      padding: "500",
      type: "warning",
      closeable: false,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendarView.fixIntegrationWarning.title"
      }),
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendarView.fixIntegrationWarning.body"
      }), /*#__PURE__*/_jsx(Button, {
        "data-onboarding": "reconnect-calendar-button",
        "data-selenium-test": "reconnect-calendar-button",
        use: "tertiary",
        onClick: () => {
          setConnectFlowOpen(true);
          setOAuthError(null);
          setOAuthErrorHidden(false);
        },
        marginInlineStart: "600",
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "calendarView.fixIntegrationWarning.action"
        })
      })]
    }), connectFlowOpen && /*#__PURE__*/_jsx(LoadableConnectCalendarModal, {
      onClose: () => setConnectFlowOpen(false),
      onOAuthError: errorData => setOAuthError(errorData.payload)
    })]
  });
}